<template>
    <div class="diagram_roof">
        <div class="diagram_roof_box">
            <div class="roof_left">
                <el-scrollbar style="height: 100%;width: 100%;">
                    <div class="roof_menu" v-for="(item, index) in menu" :key="id" @click="clickMenu(item)">
                        <div class="roof_alarm_icon" v-if="item.data"></div>
                        <div style="width: 2.6rem; height: 1.3rem;" v-else></div>
                        <div
                            :class="[curMenuId == item.id ? 'roof_menu_common roof_menu_se' : 'roof_menu_common roof_menu_un']">
                            {{ item.name }}</div>
                    </div>
                </el-scrollbar>
            </div>
            <div class="roof_center">
                <div class="roof_title">警报信息</div>
                <div class="roof_center_wrapper" v-if="curMenuId == 1">
                    <img src="../../../assets/image/diagram/changfang1.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in changfang1" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 2">
                    <img src="../../../assets/image/diagram/changfang1_tu.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in changfang1_tu" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 3">
                    <img src="../../../assets/image/diagram/changfang2.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in changfang2" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 4">
                    <img src="../../../assets/image/diagram/hv.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in hv" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 5">
                    <img src="../../../assets/image/diagram/mv.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in mv" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 6">
                    <img src="../../../assets/image/diagram/jueyuanchejian.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in jueyuanchejian" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 7">
                    <img src="../../../assets/image/diagram/jueyuanchejian_tu.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in jueyuanchejian_tu" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
                <div class="roof_center_wrapper" v-else-if="curMenuId == 8">
                    <img src="../../../assets/image/diagram/shengchanchejian.png" class="roof_center_pic">
                    <div :style="`position: absolute; top:${item.top + '%'};left:${item.left + '%'};`"
                        v-for="(item, index) in shengchanchejian" :key="index">
                        <img src="../../../assets/image/diagram/roof_center_alarm.png" v-if="item.data == 1"
                            class="roof_center_alarm">
                    </div>
                </div>
            </div>
            <div class="roof_right">
                <div class="roof_title">警报信息</div>
                <div class="roof_right_cnt">
                    <el-scrollbar style="height: 100%;width: 100%;">
                        <div class="roof_right_item" v-for="(item, index) in curList" :key="id">
                            <div class="roof_right_know" @click="doClose(item, index)">已了解</div>
                            <div class="roof_right_item_title">{{ item.point_name }}</div>
                            <div class="roof_right_item_cnt">
                                <div class="roof_right_item_detail">{{ item.warn_detail }}</div>
                                <div class="roof_right_item_cnt_icon"></div>
                                <div style="color: red;">报警</div>
                            </div>
                            <div style="width: 100%;">
                                <img src="../../../assets/image/diagram/roof_right_line.png"
                                    class="roof_right_item_cnt_line">
                            </div>
                            <div class="roof_right_item_cnt">
                                <div class="roof_right_item_cnt_time"></div>
                                <div style="flex: 1; text-align: right;">{{ item.op_date }}</div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import { changfang1, changfang1_tu, changfang2, hv, mv, jueyuanchejian, jueyuanchejian_tu, shengchanchejian } from "./roofData.js";
export default {
    data() {
        return {
            changfang1: changfang1,
            changfang1_tu: changfang1_tu,
            changfang2: changfang2,
            jueyuanchejian: jueyuanchejian,
            jueyuanchejian_tu: jueyuanchejian_tu,
            shengchanchejian: shengchanchejian,
            hv: hv,
            mv: mv,
            menu: [
                { id: 1, name: '1#厂房' },
                { id: 2, name: '1#厂房-混凝土' },
                { id: 3, name: '2#厂房' },
                { id: 4, name: 'HV车间' },
                { id: 5, name: 'MV车间' },
                { id: 6, name: '绝缘车间' },
                { id: 7, name: '绝缘车间-混凝土' },
                { id: 8, name: '生产车间' },
            ],
            infoList: [],
            curMenuId: 1,
            changfang1_list: [],
            changfang1_tu_list: [],
            changfang2_list: [],
            hv_list: [],
            mv_list: [],
            jueyuanchejian_list: [],
            jueyuanchejian_tu_list: [],
            shengchanchejian_list: [],
            curList: [],
            timer: null,
        };
    },
    mounted() {
        this.getWarn_zbList();
        this.setTimer();
    },
    methods: {
        doClose(item, index) {
            api.updateWarn_zb({warn_zb_id: item.warn_zb_id}).then(res => {
                if (res) {
                    this.$message({
                        message: '操作成功',
                        type: "success",
                    });
                    this.getWarn_zbList();
                }
            });
        },
        getWarn_zbList() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            const point_id = [];
            this.changfang1_list = [];
            this.changfang1_tu_list = [];
            this.changfang2_list = [];
            this.hv_list = [];
            this.mv_list = [];
            this.jueyuanchejian_list = [];
            this.jueyuanchejian_tu_list = [];
            this.shengchanchejian_list = [];
            this.changfang1.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.changfang1_tu.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.changfang2.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.hv.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.mv.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.jueyuanchejian.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.jueyuanchejian_tu.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            this.shengchanchejian.forEach(item => {
                point_id.push(item.point_id);
                item.data = '';
            })
            api.getWarn_zbList({
                pageNum: 1,
                pageSize: 9999,
                is_read: 0,
                point_id: point_id.join(','),
            }).then(res => {
                if (res) {
                    this.infoList = res.bus_json.items;
                    this.curList = [];

                    this.infoList.forEach(item => {
                        this.changfang1.forEach(data => {
                            if (data.point_id == item.point_id) this.changfang1_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.changfang1_tu.forEach(data => {
                            if (data.point_id == item.point_id) this.changfang1_tu_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.changfang2.forEach(data => {
                            if (data.point_id == item.point_id) this.changfang2_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.hv.forEach(data => {
                            if (data.point_id == item.point_id) this.hv_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.mv.forEach(data => {
                            if (data.point_id == item.point_id) this.mv_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.jueyuanchejian.forEach(data => {
                            if (data.point_id == item.point_id) this.jueyuanchejian_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.jueyuanchejian_tu.forEach(data => {
                            if (data.point_id == item.point_id) this.jueyuanchejian_tu_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                        this.shengchanchejian.forEach(data => {
                            if (data.point_id == item.point_id) this.shengchanchejian_list.push(item);
                            if (!data.data) {
                                if (data.point_id == item.point_id) {
                                    data.data = 1;
                                } else data.data = 0;
                            }
                        })
                    })
                    this.menu.forEach(item => {
                        if (item.id == 1) item['data'] = this.changfang1_list.length;
                        else if (item.id == 2) item['data'] = this.changfang1_tu_list.length;
                        else if (item.id == 3)  item['data'] = this.changfang2_list.length;
                        else if (item.id == 4)  item['data'] = this.hv_list.length;
                        else if (item.id == 5)  item['data'] = this.mv_list.length;
                        else if (item.id == 6)  item['data'] = this.jueyuanchejian_list.length;
                        else if (item.id == 7) item['data'] = this.jueyuanchejian_tu_list.length;
                        else if (item.id == 8) item['data'] = this.shengchanchejian_list.length;
                    })
                    if (this.curMenuId == 1) this.curList = this.changfang1_list;
                    else if (this.curMenuId == 2) this.curList = this.changfang1_tu_list;
                    else if (this.curMenuId == 3) this.curList = this.changfang2_list;
                    else if (this.curMenuId == 4) this.curList = this.hv_list;
                    else if (this.curMenuId == 5) this.curList = this.mv_list;
                    else if (this.curMenuId == 6) this.curList = this.jueyuanchejian_list;
                    else if (this.curMenuId == 7) this.curList = this.jueyuanchejian_tu_list;
                    else if (this.curMenuId == 8) this.curList = this.shengchanchejian_list;
                }
                if (loading) loading.close();
            });
        },
        clickMenu(item) {
            this.curMenuId = item.id;
            if (this.curMenuId == 1) this.curList = this.changfang1_list;
            else if (this.curMenuId == 2) this.curList = this.changfang1_tu_list;
            else if (this.curMenuId == 3) this.curList = this.changfang2_list;
            else if (this.curMenuId == 4) this.curList = this.hv_list;
            else if (this.curMenuId == 5) this.curList = this.mv_list;
            else if (this.curMenuId == 6) this.curList = this.jueyuanchejian_list;
            else if (this.curMenuId == 7) this.curList = this.jueyuanchejian_tu_list;
            else if (this.curMenuId == 8) this.curList = this.shengchanchejian_list;
        },
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getWarn_zbList();
            }, 1000 * 30);
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.diagram_roof {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    box-sizing: border-box;

    .diagram_roof_box {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        display: inline-flex;

        .roof_left {
            width: 15%;
            height: 100%;
            margin-right: 1%;

            .roof_menu {
                width: 100%;
                //height: 3rem;
                display: inline-flex;
                align-items: center;
                margin-bottom: 0.5rem;
                cursor: pointer;

                .roof_alarm_icon {
                    width: 2.6rem;
                    height: 1.3rem;
                    background: url("../../../assets/image/diagram/roof_menu_alarm.png") no-repeat center center;
                    background-size: 50% 100%;
                }

                .roof_menu_common {
                    flex: 1;
                    height: 3rem;
                    line-height: 3rem;
                    font-size: 0.7rem;
                }

                .roof_menu_un {
                    background: url("../../../assets/image/diagram/roof_menu_un.png") no-repeat;
                    background-size: auto 100%;
                }

                .roof_menu_se {
                    background: url("../../../assets/image/diagram/roof_menu_se.png") no-repeat;
                    background-size: auto 100%;
                }
            }
        }

        .roof_center {
            width: 64%;
            height: 100%;
            background: url("../../../assets/image/diagram/roof_center_bak.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            display: inline-flex;
            align-items: center;
            box-sizing: border-box;
            padding: 3% 2% 1%;
            // padding-top: 3.5%;
            //   overflow: hidden;

            .roof_title {
                position: absolute;
                top: 3.6%;
                left: 25px;
                font-size: 0.7rem;
            }

            .roof_center_alarm {
                width: 4rem;
                height: 2rem;
                // background: url("../../../assets/image/diagram/roof_center_alarm.png") no-repeat;
                // background-size: 100% auto;
                // position: absolute;
                // top: 54%;
                // left: 16%;
                //z-index: 9;
            }

            .roof_center_wrapper {
                position: relative;
                width: 100%;

                //  height: 100%;
                .roof_center_pic {
                    width: 100%;
                    height: auto; //100%;
                    //object-fit: contain;
                }
            }
        }

        .roof_right {
            width: 19%;
            height: 100%;
            margin-left: 1%;
            background: url("../../../assets/image/diagram/roof_right_bak.png") no-repeat;
            background-size: 100% 100%;
            position: relative;

            .roof_title {
                position: absolute;
                top: 3.3%;
                left: 25px;
                font-size: 0.7rem;
            }

            .roof_right_cnt {
                width: 90%;
                height: 91%;
                margin: 15% 5% 0 5%;

                .roof_right_item {
                    width: 100%;
                    height: 6rem;
                    background: url("../../../assets/image/diagram/roof_right_border.png") no-repeat;
                    background-size: 100% 100%;
                    position: relative;
                    font-size: 0.7rem;
                    padding: 0.5rem 1rem;
                    box-sizing: border-box;
                    margin-bottom: 0.8rem;

                    .roof_right_know {
                        position: absolute;
                        top: 8%;
                        right: 0;
                        width: 4rem;
                        height: 1.5rem;
                        line-height: 1.5rem;
                        font-size: 0.7rem;
                        color: #56fcff;
                        background: url("../../../assets/image/diagram/roof_right_x.png") no-repeat;
                        background-size: auto 100%;
                        text-align: left;
                        text-indent: 0.5em;
                        transform: scale(0.8);
                        cursor: pointer;
                    }

                    .roof_right_item_title {
                        height: 1.5rem;
                        line-height: 1.5rem;
                        width: 100%;
                        color: #56fcff;
                        text-align: left;
                        // text-indent: 1.5em;
                    }

                    .roof_right_item_cnt {
                        height: 1.5rem;
                        line-height: 1.5rem;
                        width: 100%;
                        text-align: left;
                        // text-indent: 1.5em;
                        display: inline-flex;
                        align-items: center;

                        .roof_right_item_cnt_icon {
                            width: 1rem;
                            height: 1rem;
                            background: url("../../../assets/image/diagram/roof_right_alarm.png") no-repeat;
                            background-size: auto 100%;
                        }

                        .roof_right_item_cnt_time {
                            width: 0.7rem;
                            height: 0.7rem;
                            background: url("../../../assets/image/diagram/roof_right_time.png") no-repeat;
                            background-size: auto 100%;
                        }

                        .roof_right_item_detail {
                            flex: 1;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }

                    .roof_right_item_cnt_line {
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }
}</style>
